export const alertText =
  "Please ask questions that are related to the topic of today's lesson."
export const alertTitle = 'Chat GPT-4'
